import { IssueDetailsContextValue } from "./IssueDetailsContext.types";
import { createContext } from "react";

export const IssueDetailsContext = createContext<IssueDetailsContextValue>({
  currentAttachment: null,
  attachments: [],
  updateCurrentAttachment: () => {},
});
